/* eslint-disable no-plusplus */
import { message } from 'antd';
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import editAdminVacancyAPI, { IEditVacancyParams } from '../../api/edit-admin-vacancy';
import {
  receiveVacancyEdit,
  rejectVacancyEdit,
  requestAdminVacancies,
  requestOthersVacancies,
  requestVacancyEdit,
  requestVacancyGroup,
} from '../actions/admin-page';

interface IGetCityAction {
  type: string;
  payload: {
    id: string | string[];
    division: string;
    searchValue: string;
    editParams: IEditVacancyParams;
    group: string;
  }
}
const editVacancy = function* editVacancyGroup(action: IGetCityAction) {
  try {
    if (typeof action.payload.id === 'string') {
      yield call(editAdminVacancyAPI, action.payload.id, action.payload.editParams);
    } else {
      for (let i = 0; i < action.payload.id.length; i++) {
        yield call(editAdminVacancyAPI, action.payload.id[i], action.payload.editParams);
      }
    }
    yield put(requestAdminVacancies({
      division: action.payload.division,
      searchValue: action.payload.searchValue,
      group: action.payload.group,
      mode: 'compact',
    }));
    yield put(requestOthersVacancies({
      mode: 'compact',
      searchValue: '',
    }));
    yield put(requestVacancyGroup({
      division: action.payload.division,
    }));
    yield put(receiveVacancyEdit());
    message.success({
      content: 'Изменения успешно сохранены',
      style: { textAlign: 'right' },
    });
  } catch (error) {
    yield put(rejectVacancyEdit({ error }));
  }
};

export default function* editVacancyWatcher() {
  yield takeLatest(requestVacancyEdit, editVacancy);
}
